import { useEffect } from "react";
import type { Order } from "@/api.types.v2";

export function useProofMediaPreconnect(orders: Order[] | undefined) {
  useEffect(() => {
    // Proof images mount only when order details opens; connect while the list is visible.
    const proofUrls =
      orders?.flatMap((order) =>
        (order.shipments ?? []).flatMap((shipment) =>
          (shipment.tasks ?? []).flatMap((task) =>
            (task.proof?.mediaItems ?? []).map(
              (item) => item.thumbnailUrl || item.url
            )
          )
        )
      ) ?? [];

    for (const source of proofUrls) {
      let url: URL;
      try {
        url = new URL(source);
      } catch {
        continue;
      }
      if (
        url.protocol !== "https:" ||
        !/^[a-z0-9-]+\.s3\.[a-z0-9-]+\.amazonaws\.com$/.test(url.hostname)
      ) {
        continue;
      }
      const alreadyConnected = Array.from(
        document.head.querySelectorAll<HTMLLinkElement>(
          'link[rel="preconnect"]'
        )
      ).some((link) => new URL(link.href).origin === url.origin);
      if (!alreadyConnected) {
        const link = document.createElement("link");
        link.rel = "preconnect";
        link.href = url.origin;
        document.head.appendChild(link);
      }
      return;
    }
  }, [orders]);
}
